module.exports = __webpack_public_path__ + "static/img/record-bg.d77d56b3.png";